import { render, staticRenderFns } from "./MacroAnalysisTabel.vue?vue&type=template&id=1679a055&scoped=true"
import script from "./MacroAnalysisTabel.vue?vue&type=script&lang=js"
export * from "./MacroAnalysisTabel.vue?vue&type=script&lang=js"
import style0 from "./MacroAnalysisTabel.vue?vue&type=style&index=0&id=1679a055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1679a055",
  null
  
)

export default component.exports